const extractBookAppointmentError = (failures)=>{
    var ref;
    if (failures && failures.length > 0 && ((ref = failures[0]) === null || ref === void 0 ? void 0 : ref.__typename)) {
        return failures[0].__typename;
    }
};

export { extractBookAppointmentError };
//# sourceMappingURL=extract-book-appointment-error.js.map
